export default "__VITE_ASSET__a3700da7__"